export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderGroup@2x.png";